export const AUTH_USER = "auth_user";
export const WAITING_AUTH = "waiting_auth";
export const AUTH_ERROR = "auth_error";

export const LOADING_STORES = "loading_stores";
export const STORES_LOADED = "stores_loaded";
export const LOADING_STORES_ERROR = "loading_stores_error";

export const LOADING_COUSINES = "loading_cousines";
export const COUSINES_LOADED = "cousines_loaded";
export const LOADING_COUSINES_ERROR = "loading_cousines_error";



// WEBPACK FOOTER //
// ./src/actions/types.js